<template>
    <div class="amd-promo-hero">
        <div class="container">
            <div class="col-md-6">
                <div class="amd-promo-hero__image">
                    <div class="amd-promo-hero__logo">
                        <img src="/images/amd-promo/amd-logo-and-games.png" alt="AMD logo and Borderlands 3, The Outer Worlds and Xbox Games Pass for PC covers">
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="amd-promo-hero__content">
                    <h1 class="amd-promo-hero__heading text-uppercase">
                        UP TO 2 FREE games
                        with AMD Ryzen
                    </h1>
                    <div class="amd-promo-hero__builds">
                        <div class="amd-promo-hero__build">
                            <p class="amd-promo-hero__build__description">
                                Borderlands 3 + The Outer Worlds + 3 months of Xbox Game Pass for PC*

                            </p>
                            <button
                                class="btn amd-promo-hero__build__button"
                                @click="$emit('customize-build', builds[0].bld_number)"
                            >
                                Shop RYZEN 9 3900X
                            </button>
                        </div>
                        <hr class="hidden-sm">
                        <div class="amd-promo-hero__build">
                            <p class="amd-promo-hero__build__description">
                                Borderlands 3 or The Outer Worlds + 3 months of Xbox Game Pass for PC*

                            </p>
                            <button
                                class="btn amd-promo-hero__build__button"
                                @click="$emit('customize-build', builds[1].bld_number)"
                            >
                                Shop Ryzen 7 3700X
                            </button>
                        </div>
                        <hr class="hidden-sm">
                        <div class="amd-promo-hero__build">
                            <p class="amd-promo-hero__build__description">
                                3 months of Xbox Game Pass for PC*

                            </p>
                            <button
                                class="btn amd-promo-hero__build__button"
                                @click="$emit('customize-build', builds[2].bld_number)"
                            >
                                Shop Ryzen 5 3600
                            </button>
                        </div>
                        <p class="amd-promo-hero__build__offer">
                            *Offer valid through 2/15/20 while supplies last.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AmdPromoHero",
    props: {
        builds: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.amd-promo-hero {
    background-image: url("/images/amd-promo/amd-promo-hero-bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 80px 0;
    margin: 0 -15px;

    @media (max-width: 991px) {
        padding-top: 0;
        padding-bottom: 0;

        .col-md-6 {
            padding: 0;
        }
    }

    .col-md-6:last-child {
        padding-right: 0;
    }

    &__image {
        padding-top: 85px;

        @media (max-width: 991px) {
            padding-top: 35px;
        }
    }

    &__logo {
        text-align: center;
        padding-right: 60px;
        padding-top: 40px;

        @media (max-width: 991px) {
            padding-right: 0;
        }

        @media (max-width: 767px) {
            padding-top: 0;
        }

        img {
            @media (max-width: 400px) {
                width: 100%;
            }
        }
    }

    &__content {
        @media (min-width: 768px) and (max-width: 991px) {
            padding: 0 75px 50px;
            margin-bottom: 50px;
        }

        @media (max-width: 767px) {
            padding-left: 0;
        }
    }

    hr {
        opacity: .15;
        display: none;

        @media (max-width: 767px) {
            display: block;
        }
    }

    &__heading {
        margin-bottom: 35px;
        color: $white;
        font-size: 48px;
        line-height: 54px;

        @media (max-width: 767px) {
            font-size: 32px;
            line-height: 38px;
            margin-bottom: 20px;
        }
    }

    &__build {
        margin-bottom: 35px;

        &__description {
            color: $white;
            font-size: 16px;
            line-height: 22px;

            @media (max-width: 767px) {
                margin-bottom: 30px;
            }
        }

        &__offer {
            color: $white;
            font-size: 16px;
            margin: 20px 0;
        }

        &__button {
            padding: 16px 35px;
            border-radius: 5px;
            background-color: #51007A;
            color: #FFFFFF;
            margin-right: 15px;
            font-family: "Akkurat-Normal", "Helvetica Neue", "Helvetica", Arial, sans-serif;
            min-width: 220px;

            @media (max-width: 1200px) {
                padding: 16px 30px;
            }

            @media (max-width: 991px) {
                width: 100%;
                margin: 0;
            }

            @media (max-width: 768px) {
                padding: 16px 25px;
            }

            &:hover {
                color: #51007A;
                background-color: #FFFFFF;
            }

        }
    }
}
</style>
